import type { ReactNode } from 'react';
import { useChatQuerySocket } from '@trinity/chat-components/websocket';
import { QuerySocketContext } from './context';

type Props = {
  queryIdentifier: string;
  children: ReactNode;
};

export const QuerySocketContainer = ({ queryIdentifier, children }: Props) => {
  const socket = useChatQuerySocket(queryIdentifier);

  return (
    <QuerySocketContext.Provider value={socket}>
      {children}
    </QuerySocketContext.Provider>
  );
};
